export const projectUiCopy = {
  ko: {
    sectionTitle: "Core Projects",
    sectionIntro:
      "사용자의 반복적인 불편, 기록되지 않는 의사결정, 재생에너지 수요 불일치 등 서로 다른 문제를 서비스 구조로 해결하려 한 경험입니다.",
    coreKicker: "Submission focus",
    coreTitle: "제출용 핵심 프로젝트 3",
    coreIntro:
      "문제정의, 수행 역할, 기술 선택, 해결 과정이 면접 질문으로 이어지도록 ARGUS, DailyLog, Loggy를 먼저 정리합니다.",
    supportingKicker: "Supporting / Hackathon",
    supportingTitle: "보조 프로젝트 및 해커톤",
    supportingIntro:
      "도메인 확장성, 빠른 실행력, 추가 아이디어를 보여주는 프로젝트는 하단 아카이브로 분리합니다.",
    problemDefinition: "한 줄 문제정의",
    coreContribution: "핵심 기여",
    techStack: "사용 기술",
    resultLearning: "결과 / 배운 점",
    submissionFormat: "SSAFY 제출 구조",
    overview: "프로젝트 개요",
    myRole: "수행 역할",
    solutionProcess: "해결 과정",
    interviewHooks: "면접 질문 포인트",
    viewDetails: "상세 보기",
    backToProjects: "프로젝트 목록으로 돌아가기",
    period: "기간",
    team: "팀 구성",
    role: "역할",
    links: "링크",
    highlights: "핵심 포인트",
    screens: "서비스 화면",
    themes: "키워드",
    challenge: "다룬 문제",
    insight: "구조적 인사이트",
    solution: "경험 설계 + 시스템 구조",
    artifacts: "추가 예정 자료",
    artifactEmpty:
      "와이어프레임, 화면 이미지, 코드 링크, 발표 자료를 프로젝트별로 순차적으로 정리할 예정입니다.",
    github: "GitHub",
    demo: "서비스 링크",
    docs: "문서 자료",
    video: "데모 영상",
    linksPending: "링크 정리 중",
    statusLabels: {
      planning: "Planning",
      in_progress: "In Progress",
      completed: "Completed",
      archive_preparing: "Archive Prep",
    },
  },
  en: {
    sectionTitle: "Core Projects",
    sectionIntro:
      "Experiences in solving various problems—user friction, fragmented decisions, and energy mismatches—through structured service design.",
    coreKicker: "Submission focus",
    coreTitle: "Core 3 Projects",
    coreIntro:
      "ARGUS, DailyLog, and Loggy are prioritized to show problem framing, role, technical choices, and solution process as interview-ready cases.",
    supportingKicker: "Supporting / Hackathon",
    supportingTitle: "Supporting Projects & Hackathons",
    supportingIntro:
      "Additional projects are separated as archive cases that show domain expansion, rapid execution, and supporting ideas.",
    problemDefinition: "Problem definition",
    coreContribution: "Key contribution",
    techStack: "Tech stack",
    resultLearning: "Result / learning",
    submissionFormat: "SSAFY Portfolio Format",
    overview: "Project overview",
    myRole: "My role",
    solutionProcess: "Solution process",
    interviewHooks: "Interview hooks",
    viewDetails: "View details",
    backToProjects: "Back to project archive",
    period: "Period",
    team: "Team",
    role: "Role",
    links: "Links",
    highlights: "Highlights",
    screens: "Product Screens",
    themes: "Themes",
    challenge: "Challenge",
    insight: "Structural Insight",
    solution: "Experience + System Design",
    artifacts: "Planned archive assets",
    artifactEmpty:
      "Wireframes, UI captures, code links, and supporting documents will be attached as each project archive is documented.",
    github: "GitHub",
    demo: "Live link",
    docs: "Docs",
    video: "Demo video",
    linksPending: "Links in preparation",
    statusLabels: {
      planning: "Planning",
      in_progress: "In Progress",
      completed: "Completed",
      archive_preparing: "Archive Prep",
    },
  },
};
